<template>
  <div class="row">
    <div :class="[validatedSectionClass, generalClass]" class="col-md-12">
      <!-- gender.length <= 4 -->
      <div v-if="this.$store.state.gender.length <= 4 && this.$store.state.requirements['gender']">
        <div class="row mt-5">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <label
                class="control-label"
                :class="modelValidations.gender['required'] ? 'required' : ''"
                for="gender"
              >
                {{computeReportableCaption('gender', this.fields_en['gender'], this.$store.state.lang.value.toLowerCase())}}
              </label><br>
              <div class="default-grey font-small" v-show="getFieldDescription('gender')" v-html="getFieldDescription('gender') || ''">
              </div>
              <el-radio-group
                size="small"
                data-vv-as="Gender"
                id="gender"
                v-validate="modelValidations.gender"
                placeholder="Single Select"
                name="gender"
                v-model="model.gender"
              >
                <el-radio-button
                  v-for="option in this.$store.state.gender"
                  :value="option.name"
                  :label="option.name"
                  :key="option.name"
                  tabindex="0"
                >{{computeCaption(option.name, $store.state.lang.value.toLowerCase())}}
                </el-radio-button>
              </el-radio-group>
              <div class="form-group">
                <small class="text-danger col-md-0" v-show="gender.invalid">
                  {{computeCaption(getError("gender"), this.$store.state.lang.value.toLowerCase())}}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- dob -->
      <div v-if="(this.$store.state.requirements['gender'] === undefined || this.$store.state.requirements['gender'] === '') || (this.$store.state.gender.length <= 4 && this.$store.state.requirements['gender'])" class="row">
        <div class="col-md-5 col-md-offset-1">
          <DobSection label="Date Of Birth" :field="'date_of_birth'" ref="dobSection" :dateValue="$store.state.userData.dob"
                      @updateDob="updateDob" :yearsProp="dobYears" :restrictDate="true"/>
        </div>
      </div>
      <!-- gender.length > 4 & dob-->
      <div v-if="this.$store.state.gender.length > 4 && this.$store.state.requirements['gender']" class="row">
        <!-- Gender -->
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label
              class="control-label"
              :class="modelValidations.gender['required'] ? 'required' : ''"
              for="gender"
            >
              {{computeReportableCaption('gender', this.fields_en['gender'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select
              size="large"
              id="gender1"
              data-vv-as="Gender"
              v-validate="modelValidations.gender"
              placeholder="Single Select"
              name="gender"
              v-model="model.gender"
            >
              <el-option
                v-for="option in this.$store.state.gender"
                class="select-danger"
                :value="option.name"
                :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('gender')" v-html="getFieldDescription('gender') || ''"></div>
            <small class="text-danger" v-show="gender.invalid">
              {{computeCaption(getError("gender"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
        <!-- dob -->
        <div class="col-md-5">
          <div class="form-group">
            <DobSection label="Date Of Birth" :field="'date_of_birth'" ref="dobSection" :dateValue="$store.state.userData.dob || ''"
                        @updateDob="updateDob" :yearsProp="dobYears" :restrictDate="true"/>
          </div>
        </div>
      </div>
      <!-- guardian data -->
      <div v-if="type === 'Registration' || type === undefined || type === 'dependentRegistration' || type === 'dependentUpdate'">
        <div v-if="guardian_info" class="row">
          <div class="col-md-5 col-md-offset-1">
            <div class="form-group">
              <label class="control-label required">
                {{computeReportableCaption('guardian_first_name', this.fields_en['guardian_first_name'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <input
                class="form-control"
                type="text"
                data-vv-as="Guardian's First Name"
                name="guardianFirstName"
                v-validate="modelValidations.guardianFirstName"
                v-model="model.guardianFirstName"
                placeholder="ex: Mike"
                :disabled="model.guardianFirstName !== '' && (type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected) || (type === undefined && $store.state.dependentSelected))"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
              />
              <div class="default-grey font-small" v-show="getFieldDescription('guardian_first_name')" v-html="getFieldDescription('guardian_first_name') || ''"></div>
              <small class="text-danger" v-show="guardianFirstName.invalid">
                {{computeCaption(getError("guardianFirstName", "First"), this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label required">
                {{computeReportableCaption('guardian_last_name', this.fields_en['guardian_last_name'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <input
                class="form-control"
                type="text"
                data-vv-as="Guardian's Last Name"
                name="guardianLastName"
                v-validate="modelValidations.guardianLastName"
                v-model="model.guardianLastName"
                placeholder="ex: Andrew"
                :disabled="model.guardianLastName !== '' && (type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected) || (type === undefined && $store.state.dependentSelected))"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
              />
              <div class="default-grey font-small" v-show="getFieldDescription('guardian_last_name')" v-html="getFieldDescription('guardian_last_name') || ''"></div>
              <small class="text-danger" v-show="guardianLastName.invalid">
                {{computeCaption(getError("guardianLastName"), this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
        </div>
        <div class="row" v-if="guardian_info">
          <div class="col-md-5 col-md-offset-1">
            <div class="form-group">
              <DobSection label="Guardian Date Of Birth" :field="'guardian_dob'" ref="dobGuardianSection"
                          :disabled="model.guardian_dob !== '' && (type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected) || (type === undefined && $store.state.dependentSelected))"
                          @updateDob="updateDobGuardian"
                          :dateValue="(type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected) || (type === undefined && $store.state.dependentSelected)) ? $store.state.patientRegistrationData.dob ? $store.state.patientRegistrationData.dob : $store.state.patientRegistrationData.date_of_birth : ''"
                          :yearsProp="dobYearsGuardian" :restrictDate="true"/>
            </div>
          </div>
        </div>
      </div>
      <!-- Guardian Address -->
      <div class="row">
        <div v-if="this.$store.state.requirements['address'] && guardian_info" class="col-md-10 col-md-offset-1">
          <Address
            id="insurance"
            @updateAddress="updateGuardianAddress"
            @updateAddress2="updateGuardianAddress2"
            :same_address2="model.address2"
            :componentsInsurance="model.guardianAddressComponents"
            :checkRequired="true"
            :is-disabled="same_address || this.type === 'dependentUpdate' || this.type === 'dependentRegistration' || this.$store.state.dependentSelected"
            wizardStep="medicalGuardian"
            ref="AddressComponent2"
          />
          <small class="text-danger" v-if="address_error">
            {{ address_error && computeCaption(address_error, $store.state.lang.value.toLowerCase()) }}
          </small>
          <div class="display-inline" v-if="guardian_info && this.type !== 'dependentUpdate' && this.type !== 'dependentRegistration' && this.$store.state.dependentSelected !== true">
            <p-checkbox
              v-model="same_address"
              name="same_address"
              v-validate="modelValidations.agreed"
            >
              {{computeCaption(fields_en['same_address_as_previous'], $store.state.lang.value.toLowerCase())}}
            </p-checkbox>
          </div>
        </div>
      </div>
      <!-- race & ethnicity -->
      <div v-if="this.$store.state.requirements['ethnicity'] && this.$store.state.requirements['race']" class="row">
        <!-- race -->
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label
              class="control-label"
              :class="modelValidations.race['required'] ? 'required' : ''"
              for="race"
            >
              {{computeReportableCaption('race', this.fields_en['race'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select
              size="large"
              id="race"
              data-vv-as="Race"
              v-validate="modelValidations.race"
              placeholder="Single Select"
              name="race"
              v-model="model.race"
            >
              <el-option
                v-for="option in this.$store.state.race"
                class="select-danger"
                :value="option.name"
                :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('race')" v-html="getFieldDescription('race') || ''"></div>
            <small class="text-danger" v-show="race.invalid">
              {{computeCaption(getError("race"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
        <!-- ethnicity -->
        <div class="col-md-5">
          <div class="form-group">
            <label
              class="control-label"
              :class="modelValidations.ethnicity['required'] ? 'required' : ''"
              for="ethnicity"
            >
              {{computeReportableCaption('ethnicity', this.fields_en['ethnicity'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select
              size="large"
              id="ethnicity"
              data-vv-as="Ethnicity"
              v-validate="modelValidations.ethnicity"
              placeholder="Single Select"
              name="ethnicity"
              v-model="model.ethnicity"
            >
              <el-option
                v-for="option in this.$store.state.ethnicity"
                class="select-danger"
                :value="option.name"
                :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('ethnicity')" v-html="getFieldDescription('ethnicity') || ''"></div>
            <small class="text-danger" v-show="ethnicity.invalid">
              {{computeCaption(getError("ethnicity"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>
      <!-- only race -->
      <div v-if="(this.$store.state.requirements['ethnicity'] === undefined || this.$store.state.requirements['ethnicity'] === '') && this.$store.state.requirements['race']" class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <label
              class="control-label"
              :class="modelValidations.race['required'] ? 'required' : ''"
              for="race"
            >
              {{computeCaption(this.fields_en['race'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select
              size="large"
              id="race"
              data-vv-as="Race"
              v-validate="modelValidations.race"
              placeholder="Single Select"
              name="race"
              v-model="model.race"
            >
              <el-option
                v-for="option in this.$store.state.race"
                class="select-danger"
                :value="option.name"
                :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('race')" v-html="getFieldDescription('race') || ''"></div>
            <small class="text-danger" v-show="race.invalid">
              {{computeCaption(getError("race"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>
      <!-- only ethnicity -->
      <div v-if="this.$store.state.requirements['ethnicity'] && (this.$store.state.requirements['race'] === undefined || this.$store.state.requirements['race'] === '')" class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <label
              class="control-label"
              :class="modelValidations.ethnicity['required'] ? 'required' : ''"
              for="ethnicity"
            >
              {{computeReportableCaption('ethnicity', this.fields_en['ethnicity'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select
              size="large"
              id="ethnicity"
              data-vv-as="Ethnicity"
              v-validate="modelValidations.ethnicity"
              placeholder="Single Select"
              name="ethnicity"
              v-model="model.ethnicity"
            >
              <el-option
                v-for="option in this.$store.state.ethnicity"
                class="select-danger"
                :value="option.name"
                :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('ethnicity')" v-html="getFieldDescription('ethnicity') || ''"></div>
            <small class="text-danger" v-show="ethnicity.invalid">
              {{computeCaption(getError("ethnicity"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vee-validate'
import {ValidationUtils} from '../../../../../utils/Validation'
import {FormatterUtils} from '../../../../../utils/Formatter.js'
import {RadioButton, RadioGroup} from 'element-ui'
import {TranslationsUtils} from '../../../../../utils/Translations.js'
import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
import {AccessionUtils} from '../../../../../utils/AccessionDetailsProcessing'
import DobSection from '../SubComponents/MultipleUseParts/Date'
import Address from './Address'
export default {
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils, AccessionUtils],
  props: ['type', 'triggerGeneticsWatch', 'configuration'],
  components: {
    DobSection,
    Address,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup
  },
  data () {
    return {
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      geneticsSectionValidation: {
        genderValidation: !this.checkRequirement('gender'),
        raceValidation: !this.checkRequirement('race'),
        ethnicityValidation: !this.checkRequirement('ethnicity'),
        dobValidation: false,
        guardianFirstNameValidation: true,
        guardianLastNameValidation: true,
        guardianDobValidation: true,
        guardianAddress: true
      },
      same_address: false,
      address_error: '',
      dobYears: [],
      dobYearsGuardian: [],
      errorDate: '',
      error_date: '',
      error_guardian_dob: '',
      guardian_info: false,
      fields_en: {
        guardian_last_name: "Guardian's Last Name",
        guardian_first_name: "Guardian's First Name",
        guardian_date_of_birth: "Guardian's Date Of Birth",
        ethnicity: 'Ethnicity',
        gender: 'Gender',
        race: 'Race',
        date_of_birth: 'Date Of Birth',
        same_address_as_previous: 'Address is the same as previously entered'
      },
      model: {
        dob: '',
        guardian_dob: (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') ? this.$store.state.patientRegistrationData['date_of_birth'] : '',
        guardianLastName: (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') ? this.$store.state.patientRegistrationData['last_name'] : '',
        guardianFirstName: (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') ? this.$store.state.patientRegistrationData['first_name'] : '',
        gender: '',
        race: '',
        ethnicity: '',
        guardianAddressComponents: {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        }
      },
      addressInitial: {
        name: '',
        original_name: '',
        delivery_line_1: '',
        city_name: '',
        county: '',
        state_abbreviation: '',
        zipcode: '',
        plus4_code: '',
        county_fips: '',
        country: ''
      },
      modelValidations: {
        gender: {
          required: this.checkRequirement('gender')
        },
        race: {
          required: this.checkRequirement('race')
        },
        ethnicity: {
          required: this.checkRequirement('ethnicity')
        },
        guardianFirstName: {
          min: 2,
          required: true
        },
        guardianLastName: {
          min: 2,
          required: true
        }
      }
    }
  },
  methods: {
    updateGuardianAddress (data) {
      this.model.guardianAddressComponents = data
      this.address_error = ''
    },
    updateGuardianAddress2 (data) {
      this.model.guardian_address2 = data
    },
    updateDob (dobObject) {
      this.model.dob = dobObject.composedDate
    },
    updateDobGuardian (dobObject) {
      this.model.guardian_dob = dobObject.composedDate
    },
    computeGeneticsValidationObject () {
      if (Object.values(this.geneticsSectionValidation).every(field => field === true)) {
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
    },
    validateAddress (objectAddress, excludedValues) {
      let flag = true
      for (let iterator in objectAddress) {
        if (!excludedValues.includes(iterator)) {
          if (objectAddress[iterator] === '') {
            flag = false
          }
        }
      }
      if (flag) {
        return true
      }
      return false
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    async validate () {
      this.$store.state.medDataValidator = false
      await this.$validator.validateAll()
      let dobValidation = await this.$refs.dobSection.validate()
      let dobGuardianValidation = true
      let addressValidation = true
      if (this.guardian_info) {
        dobGuardianValidation = await this.$refs.dobGuardianSection.validate()
        addressValidation = this.$refs.AddressComponent2.validate()
        if (!addressValidation) {
          this.address_error = 'All the required fields must be completed!'
        }
      }
      if (this.$validator.errors.items.length && (this.$validator.errors.items[0].field === 'gender' || this.$validator.errors.items[0].field === 'ethnicity' || this.$validator.errors.items[0].field === 'dob' || this.$validator.errors.items[0].field === 'race')) {
        if (this.$validator.errors.items[0].field !== 'gender') {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        } else {
          if (this.$store.state.gender.length > 4) {
            document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          } else {
            document.getElementsByName(this.$validator.errors.items[0].field)[0].childNodes[0].focus()
          }
        }
      }
      this.$store.state.dataForInsurance.dob = this.model.dob
      this.$store.state.dataForInsurance.gender = this.model.gender
      if ((await this.$validator.validateAll() === true) && dobValidation && dobGuardianValidation && addressValidation) {
        this.configuration.model.dob = this.model.dob
        this.configuration.model.guardian_dob = this.model.guardian_dob
        this.configuration.model.guardianLastName = this.model.guardianLastName
        this.configuration.model.guardianFirstName = this.model.guardianFirstName
        this.configuration.model.guardianAddressComponents = this.model.guardianAddressComponents
        this.configuration.model.guardian_address2 = this.model.guardian_address2
        this.configuration.model.gender = this.model.gender
        this.configuration.model.race = this.model.race
        this.configuration.model.ethnicity = this.model.ethnicity
        return true
      }
      return false
    },
    isEmptyObject (objectValue) {
      if (objectValue === undefined || null) {
        return true
      }
      if (Object.keys(objectValue).length > 0) {
        return false
      } else {
        return true
      }
    }
  },
  computed: {
    ...mapFields(['gender', 'race', 'ethnicity', 'dob', 'guardianFirstName', 'guardianLastName'])
  },
  watch: {
    'model.guardianAddressComponents': {
      handler: function (value) {
        let excludedValues = []
        if (this.$store.state.international) {
          excludedValues = ['name', 'original_name', 'plus4_code', 'zipcode', 'state_abbreviation', 'county_fips']
        } else {
          excludedValues = ['name', 'original_name', 'plus4_code', 'county_fips']
        }
        if (!this.isEmptyObject(this.model.guardianAddressComponents) && this.validateAddress(this.model.guardianAddressComponents, excludedValues)) {
          this.geneticsSectionValidation.guardianAddress = true
        } else {
          this.geneticsSectionValidation.guardianAddress = false
        }
      },
      deep: true
    },
    '$store.state.user.addressComponents': {
      handler: function (after, before) {
        if (this.same_address) {
          this.model.guardianAddressComponents = this.$store.state.user.addressComponents
        }
      },
      deep: true
    },
    '$store.state.insuranceData.addressComponents': {
      handler: function (after, before) {
        if (this.same_address && this.$store.state.dependentSelected) {
          this.model.guardianAddressComponents = this.$store.state.insuranceData.addressComponents
        }
      },
      deep: true
    },
    'same_address': {
      handler: function (after, before) {
        if (this.same_address) {
          if (this.type === 'dependentUpdate' || this.type === 'dependentRegistration') {
            this.model.guardianAddressComponents = this.$store.state.userData.addressComponents
          } else if (this.$store.state.dependentSelected) {
            this.model.guardianAddressComponents = this.$store.state.insuranceData.addressComponents
          } else {
            this.model.guardianAddressComponents = this.$store.state.user.addressComponents
          }
        } else {
          this.model.guardianAddressComponents = {
            name: '',
            original_name: '',
            delivery_line_1: '',
            city_name: '',
            county: '',
            state_abbreviation: '',
            zipcode: '',
            plus4_code: '',
            county_fips: '',
            country: ''
          }
        }
      }
    },
    'model.guardianFirstName': {
      handler: function (after, before) {
        if (this.$store.state.configs.ENABLE_GUARDIAN_INFO && this.guardian_info) {
          this.configuration.model.guardianFirstName = this.model.guardianFirstName
          if (this.modelValidations.guardianFirstName.required) {
            if (this.model.guardianFirstName.length > this.modelValidations.guardianFirstName.min - 1) {
              this.geneticsSectionValidation.guardianFirstNameValidation = true
            } else {
              this.geneticsSectionValidation.guardianFirstNameValidation = false
            }
          } else {
            this.geneticsSectionValidation.guardianFirstNameValidation = true
          }
        }
      }
    },
    'model.guardianLastName': {
      handler: function (after, before) {
        if (this.$store.state.configs.ENABLE_GUARDIAN_INFO && this.guardian_info) {
          this.configuration.model.guardianLastName = this.model.guardianLastName
          if (this.modelValidations.guardianLastName.required) {
            if (this.model.guardianLastName.length > this.modelValidations.guardianLastName.min - 1) {
              this.geneticsSectionValidation.guardianLastNameValidation = true
            } else {
              this.geneticsSectionValidation.guardianLastNameValidation = false
            }
          } else {
            this.geneticsSectionValidation.guardianLastNameValidation = true
          }
        }
      }
    },
    'model.gender': {
      handler: function (after, before) {
        this.$store.state.insuranceData.gender = this.model.gender
        if (this.$store.state.relationship === 'Self') {
          let dummyData = {
            gender: this.model.gender,
            dob: this.model.dob
          }
          this.$store.state.geneticsComponentInsuranceData = dummyData
        }
        this.configuration.model.gender = this.model.gender
        if (this.modelValidations.gender.required) {
          if (this.model.gender) {
            this.geneticsSectionValidation.genderValidation = true
          } else {
            this.geneticsSectionValidation.genderValidation = false
          }
        } else {
          this.geneticsSectionValidation.genderValidation = true
        }
      },
      deep: true
    },
    'model.race': {
      handler: function (after, before) {
        this.configuration.model.race = this.model.race
        if (this.modelValidations.race.required) {
          if (this.model.race) {
            this.geneticsSectionValidation.raceValidation = true
          } else {
            this.geneticsSectionValidation.raceValidation = false
          }
        } else {
          this.geneticsSectionValidation.raceValidation = true
        }
      }
    },
    'model.ethnicity': {
      handler: function (after, before) {
        this.configuration.model.ethnicity = this.model.ethnicity
        if (this.modelValidations.ethnicity.required) {
          if (this.model.ethnicity) {
            this.geneticsSectionValidation.ethnicityValidation = true
          } else {
            this.geneticsSectionValidation.ethnicityValidation = false
          }
        } else {
          this.geneticsSectionValidation.ethnicityValidation = true
        }
      }
    },
    'model.dob': {
      handler: function (dobValue) {
        if (this.$store.state.userData['dob_scanned']) {
          if (dobValue.length === 8) {
            this.model.dob = dobValue.substring(0, 2) + '/' + dobValue.substring(2, 4) + '/' + dobValue.substring(4, 8)
            this.configuration.model.dob = this.model.dob
          }
        } else {
          this.configuration.model.dob = this.model.dob
          if (dobValue.length === 10) {
            let date1 = new Date(this.model.dob)
            let ageDifMs = Date.now() - date1
            let ageDate = new Date(ageDifMs)
            let ages = (Math.abs(ageDate.getUTCFullYear() - 1970))
            if (this.$store.state.configs.ENABLE_GUARDIAN_INFO) {
              if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false) {
                if (ages < 18) {
                  this.guardian_info = true
                  if (this.type === 'Personal Data') {
                    this.guardian_info = false
                  }
                  if (this.type !== undefined || this.$store.state.dependentSelected) {
                    this.model.guardianFirstName = this.$store.state.patientRegistrationData['first_name'] ? this.$store.state.patientRegistrationData['first_name'] : this.$store.state.patientRegistrationData['firstName']
                    this.model.guardianLastName = this.$store.state.patientRegistrationData['last_name'] ? this.$store.state.patientRegistrationData['last_name'] : this.$store.state.patientRegistrationData['lastName']
                    this.model.guardian_dob = this.$store.state.patientRegistrationData['date_of_birth'] ? this.$store.state.patientRegistrationData['date_of_birth'] : this.$store.state.patientRegistrationData['dob']
                  }
                  if (this.type === undefined && !this.$store.state.dependentSelected) {
                    this.model.guardianFirstName = ''
                    this.model.guardianLastName = ''
                    this.model.guardian_dob = ''
                    this.model.guardianAddressComponents = this.addressInitial
                    this.geneticsSectionValidation.guardianDobValidation = false
                    this.geneticsSectionValidation.guardianAddress = false
                    this.geneticsSectionValidation.guardianFirstNameValidation = false
                    this.geneticsSectionValidation.guardianLastNameValidation = false
                    if (this.$refs.dobGuardianSection) {
                      this.$refs.dobGuardianSection.dateObject = {
                        year: '',
                        month: '',
                        day: '',
                        composedDate: ''
                      }
                    }
                  }
                } else {
                  this.guardian_info = false
                  this.guardian_first_name = ''
                  this.guardian_last_name = ''
                  this.geneticsSectionValidation.guardianFirstNameValidation = true
                  this.geneticsSectionValidation.guardianLastNameValidation = true
                  this.geneticsSectionValidation.guardianDobValidation = true
                  this.geneticsSectionValidation.guardianAddress = true
                  this.error_date = ''
                }
              } else {
                if (ages < 18) {
                  this.guardian_info = true
                  if (this.type === 'personalData' || (this.type === 'Registration' && this.$store.state.dependentSelected === false)) {
                    this.guardian_info = false
                  } else if (this.type !== undefined || this.$store.state.dependentSelected) {
                    this.guardian_info = true
                    this.model.guardianFirstName = this.$store.state.patientRegistrationData['first_name'] ? this.$store.state.patientRegistrationData['first_name'] : this.$store.state.patientRegistrationData['firstName']
                    this.model.guardianLastName = this.$store.state.patientRegistrationData['last_name'] ? this.$store.state.patientRegistrationData['last_name'] : this.$store.state.patientRegistrationData['lastName']
                    this.model.guardian_dob = this.$store.state.patientRegistrationData['date_of_birth'] ? this.$store.state.patientRegistrationData['date_of_birth'] : this.$store.state.patientRegistrationData['dob']
                  }
                  if (this.type === undefined && !this.$store.state.dependentSelected) {
                    this.model.guardianFirstName = ''
                    this.model.guardianLastName = ''
                    this.model.guardian_dob = ''
                    this.model.guardianAddressComponents = this.addressInitial
                    if (this.$refs.dobGuardianSection) {
                      this.$refs.dobGuardianSection.dateObject = {
                        year: '',
                        month: '',
                        day: '',
                        composedDate: ''
                      }
                    }
                    this.geneticsSectionValidation.guardianDobValidation = false
                    this.geneticsSectionValidation.guardianFirstNameValidation = false
                    this.geneticsSectionValidation.guardianLastNameValidation = false
                  }
                  let excludedValues = []
                  if (this.$store.state.international) {
                    excludedValues = ['name', 'original_name', 'plus4_code', 'zipcode', 'state_abbreviation', 'county_fips']
                  } else {
                    excludedValues = ['name', 'original_name', 'plus4_code', 'county_fips']
                  }
                  if (!this.isEmptyObject(this.model.guardianAddressComponents) && this.validateAddress(this.model.guardianAddressComponents, excludedValues)) {
                    this.geneticsSectionValidation.guardianAddress = true
                  } else {
                    this.geneticsSectionValidation.guardianAddress = false
                  }
                } else {
                  this.guardian_info = false
                  this.model.guardian_first_name = ''
                  this.model.guardian_last_name = ''
                  this.model.guardian_dob = ''
                  if (this.$refs.dobGuardianSection) {
                    this.$refs.dobGuardianSection.dateObject = {
                      year: '',
                      month: '',
                      day: '',
                      composedDate: ''
                    }
                  }
                  this.geneticsSectionValidation.guardianFirstNameValidation = true
                  this.geneticsSectionValidation.guardianLastNameValidation = true
                  this.geneticsSectionValidation.guardianDobValidation = true
                  this.geneticsSectionValidation.guardianAddress = true
                  this.error_date = ''
                }
                this.$store.state.insuranceData.dob = this.model.dob
              }
            } else {
              this.error_date = ''
              this.geneticsSectionValidation.dobValidation = true
            }
            this.$store.state.insuranceData.dob = this.model.dob
          }
          if (this.$store.state.relationship === 'Self') {
            let dummyData = {
              gender: this.model.gender,
              dob: this.model.dob
            }
            this.$store.state.geneticsComponentInsuranceData = dummyData
          }
          if (dobValue.length === 0) {
            this.$store.state.insuranceData.dob = this.model.dob
          }
          if (this.type === 'Registration') {
            this.$store.state.insuranceData.dob = this.model.dob
          }
        }
        if (!this.model.dob) {
          this.geneticsSectionValidation.dobValidation = false
        } else if (this.model.dob.length === 10) {
          this.geneticsSectionValidation.dobValidation = true
        }
      },
      deep: true
    },
    'model.guardian_dob': {
      handler: function (dobValue) {
        if (this.$store.state.configs.ENABLE_GUARDIAN_INFO && this.guardian_info) {
          if (this.model.guardian_dob.length < 10) {
            this.geneticsSectionValidation.guardianDobValidation = false
          } else {
            this.geneticsSectionValidation.guardianDobValidation = true
          }
        }
      },
      deep: true
    },
    '$store.state.requirements': {
      handler: function (after, before) {
        this.modelValidations.gender.required = this.checkRequirement('gender')
        this.modelValidations.race.required = this.checkRequirement('race')
        this.modelValidations.ethnicity.required = this.checkRequirement('ethnicity')

        this.geneticsSectionValidation = {
          genderValidation: !this.checkRequirement('gender'),
          raceValidation: !this.checkRequirement('race'),
          ethnicityValidation: !this.checkRequirement('ethnicity'),
          dobValidation: false,
          guardianFirstNameValidation: true,
          guardianLastNameValidation: true,
          guardianDobValidation: true,
          guardianAddress: true
        }
        this.$watch('geneticsSectionValidation', this.computeGeneticsValidationObject, {deep: true})
      },
      deep: true
    },
    '$store.state.relationship': {
      handler: function (after, before) {
        if (this.$store.state.relationship === 'Self') {
          let dummyData = {
            gender: this.model.gender,
            dob: this.model.dob
          }
          this.$store.state.geneticsComponentInsuranceData = dummyData
        }
      }
    },
    '$store.state.userData.gender': {
      handler (value) {
        this.model.gender = value
      }
    },
    '$store.state.userData.dob': {
      handler (value) {
        this.model.dob = value
      }
    },
    'triggerGeneticsWatch': {
      handler: function (after, before) {
        this.$watch('geneticsSectionValidation', this.computeGeneticsValidationObject, {deep: true})
      }
    }
  },
  mounted () {
    if (this.triggerGeneticsWatch === true) {
      this.$watch('geneticsSectionValidation', this.computeGeneticsValidationObject, {deep: true})
    }
  },
  beforeMount () {
    const currentYear = new Date().getFullYear()
    if (this.type === 'personalData') {
      for (let i = currentYear - 18; i >= 1900; i--) {
        this.dobYears.push(i)
      }
    }
    if (this.$store.state.configs.ENABLE_GUARDIAN_INFO) {
      if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true) {
        if (this.type === 'Registration' && this.$store.state.dependentSelected === false) {
          this.dobYears = []
          for (let i = currentYear - 18; i >= 1900; i--) {
            this.dobYears.push(i)
          }
        }
      }
    }
    for (let i = currentYear - 18; i >= 1900; i--) {
      this.dobYearsGuardian.push(i)
    }
    let token = localStorage.getItem('token')
    if (token) {
      this.model.dob = this.$store.state.userData['dob'] || ''
      this.model.gender = this.$store.state.userData['gender'] || ''
      this.model.race = this.$store.state.userData['race'] || ''
      this.model.ethnicity = this.$store.state.userData['ethnicity'] || ''
      if (this.type === 'dependentUpdate' || this.type === 'dependentRegistration' || this.$store.state.dependentSelected) {
        this.model.guardianAddressComponents = this.$store.state.patientRegistrationData['insured_address_components'] || this.addressInitial
      }
    }
    let checkInsurance = !!this.$store.state.site.bills_array.find(bill => bill.type === 'insurance')
    if (checkInsurance) {
      if (this.$store.state.requirements.gender) {
        this.$store.state.requirements.gender.required_portal = '1'
      } else {
        this.$store.state.requirements.gender = []
        this.$store.state.requirements.gender.required_portal = '1'
      }
      if (this.$store.state.requirements.address) {
        this.$store.state.requirements.address.required_portal = '1'
      } else {
        this.$store.state.requirements.address = []
        this.$store.state.requirements.address.required_portal = '1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/variables";

.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/Sections/GeneticsSection.vue